import { openDB } from 'idb';
import { getInstallationId, learnerApiFetch, type GetToken } from './learner-api';

type QueueRecord = {
  id: string;
  kind: 'event' | 'game-run';
  createdAt: string;
  attempts: number;
  payload: Record<string, unknown>;
};

const dbPromise = openDB('hmonglus-web', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('queue')) db.createObjectStore('queue', { keyPath: 'id' });
  },
});

export async function enqueueActivity(type: string, payload: Record<string, unknown>) {
  const now = new Date().toISOString();
  const record: QueueRecord = {
    id: crypto.randomUUID(),
    kind: 'event',
    createdAt: now,
    attempts: 0,
    payload: { type, client_event_uuid: crypto.randomUUID(), occurred_at: now, ...payload },
  };
  await (await dbPromise).put('queue', record);
  void flushProgressQueue(null);
}

export async function enqueueGameRun(payload: Record<string, unknown>) {
  const record: QueueRecord = {
    id: crypto.randomUUID(),
    kind: 'game-run',
    createdAt: new Date().toISOString(),
    attempts: 0,
    payload,
  };
  await (await dbPromise).put('queue', record);
  void flushProgressQueue(null);
}

export async function flushProgressQueue(getToken: GetToken | null) {
  if (!navigator.onLine) return;
  const db = await dbPromise;
  const records = (await db.getAll('queue')) as QueueRecord[];
  const events = records.filter((record) => record.kind === 'event').slice(0, 50);
  if (events.length) {
    const response = await learnerApiFetch(getToken, '/v1/events/batch', {
      method: 'POST',
      body: JSON.stringify({
        installation_id: getInstallationId(),
        app_version: import.meta.env.VITE_RELEASE || null,
        events: events.map((record) => record.payload),
      }),
    }).catch(() => null);
    if (response?.ok) await Promise.all(events.map((record) => db.delete('queue', record.id)));
  }
  for (const record of records.filter((item) => item.kind === 'game-run').slice(0, 10)) {
    const response = await learnerApiFetch(getToken, '/v1/games/runs', {
      method: 'POST',
      body: JSON.stringify({
        installation_id: getInstallationId(),
        app_version: import.meta.env.VITE_RELEASE || null,
        client_run_uuid: record.id,
        ...record.payload,
      }),
    }).catch(() => null);
    if (response?.ok || (response && response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 429)) {
      await db.delete('queue', record.id);
    }
  }
}
